var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 800C620.914 800 800 620.914 800 400C800 179.086 620.914 0 400 0C179.086 0 0 179.086 0 400C0 620.914 179.086 800 400 800Z",
    fill: "#E33333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.55 417.1V417.05C446.8 417.25 432.625 418.1 401 418.1C375.75 418.1 357.975 417.35 351.725 417.05V417.125C254.525 412.85 181.975 395.925 181.975 375.675C181.975 355.45 254.525 338.525 351.725 334.175V400.275C358.075 400.725 376.275 401.8 401.425 401.8C431.6 401.8 446.725 400.55 449.55 400.3V334.225C546.55 338.55 618.925 355.475 618.925 375.675C618.925 395.925 546.55 412.8 449.55 417.1ZM449.55 327.35V268.2H584.9V178H216.375V268.2H351.725V327.325C241.725 332.375 159 354.175 159 380.275C159 406.375 241.725 428.15 351.725 433.225V622.775H449.55V433.175C559.375 428.125 641.9 406.35 641.9 380.275C641.9 354.2 559.375 332.425 449.55 327.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.1693629815ff308e432d7bfb67223b1a.svg";
export { ForwardRef as ReactComponent };